import { getHistoricalPaymentGroupId } from '@ca/common'
import type { HistoricalPaymentGroupMember } from '@ca/common'

export const getHistoricalPaymentGroupQuery = (
  order: HistoricalPaymentGroupMember
) => ({
  customer_id: order.customer_id,
  group: getHistoricalPaymentGroupId(order),
  limit: 20,
})
